import { CreatorGraphSignals } from '../graph/creator-graph-signals';
import { FeedDiscoveryItem } from '../feed/discovery.types';
import { CreatorLifecycleState } from '../loop/creator-lifecycle';
import { FeedImpactModel } from '../loop/feed-impact.model';
import { CreatorScoreModel } from '../loop/creator-score.model';

/** Inputs required to produce a feed rank order (contract only). */
export interface FeedGenerationContractInput {
  creatorId: string;
  scores: CreatorScoreModel;
  feedImpact: FeedImpactModel;
  graphSignals: CreatorGraphSignals;
  lifecycleState: CreatorLifecycleState;
}

/** Single ranked feed slot — abstract ordering, no ranking algorithm. */
export interface FeedItemRankOrderEntry {
  itemId: string;
  itemType: FeedDiscoveryItem['type'];
  rank: number;
}

/** Output of feed generation: ordered items ready for rendering. */
export interface FeedItemRankOrder {
  creatorScope: 'global' | 'creator';
  entries: FeedItemRankOrderEntry[];
  generatedAt: Date;
}

/**
 * Feed generation contract — binds scores, feed impact, graph signals, and lifecycle
 * into a rank order output. Algorithm implementation is out of scope.
 */
export interface FeedGenerationContract {
  input: FeedGenerationContractInput;
  output: FeedItemRankOrder;
}
